import { render } from "./OverviewBody.vue?vue&type=template&id=67f6d59b&scoped=true"
import script from "./OverviewBody.vue?vue&type=script&lang=js"
export * from "./OverviewBody.vue?vue&type=script&lang=js"

import "./OverviewBody.vue?vue&type=style&index=0&id=67f6d59b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f6d59b"]])

export default __exports__